<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      v-if="bot != undefined"
      wrap
    >
      <v-flex 
        xs12
        md5
      >
        <v-card>
          <v-flex
            xs12
          >
            <v-text-field
              v-model="accountName"
              name="account-name"
              :label="this.$t('bots.accountName')"
              :placeholder="this.$t('bots.accountNamePlaceholder')"
              :error-messages="errorMessages"
              @input="$v.accountName.$touch()"
              @blur="$v.accountName.$touch()"
            />
            <div
              v-for="(field,i) in config_schema"
              :key="i" 
            >
              <component 
                :is="loadField(field.field)"
                :ref="field.key"
                :opts="field"
                :config="botConfig != null ? botConfig[field.key] : null"
              />
            </div>
          </v-flex>    
            
             
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              :disabled="loading"
              @click="$router.go(-1)"
            >
              {{ $t('globals.cancelButton') }}
            </v-btn>
            <v-btn
              :disabled="loading"
              :loading="loading"
              class="primary"
              @click="$route.query.ubid == undefined 
                ? mutateBot('install') 
                : mutateBot('update')"
            >
              {{ $route.query.ubid == undefined 
                ? $t('bots.installButton')
                : $t('bots.changeButton') }}
            </v-btn> 
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import BotText from '@/views/TraderBots/partial/Text.vue'
import BotSelect from '@/views/TraderBots/partial/Select.vue'
import BotCheckbox from '@/views/TraderBots/partial/Checkbox.vue'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const CREATE_USERBOT_MUTATION = require('@/graphql/mutations/CreateUserBot.gql');
const MANAGE_USERBOT_MUTATION = require('@/graphql/mutations/ManageUserBot.gql');

const BOT_INSTALL_QUERY = require('@/graphql/queries/BotInstall.gql');
const USER_BOT_QUERY = require('@/graphql/queries/UserBot.gql');

export default {
  name: 'Bots',
  components: { 
    BotText,
    BotSelect,
    BotCheckbox
  },
  mixins: [validationMixin],
  data() {
    return {
      accountName: null,
      config_schema: null,
      botConfig: null,
      loading: false
    }
  },
  computed: {
    loadField() {
       return value => ('bot-' + value)
    },
    errorMessages () {
      const errors = []
      if (!this.$v.accountName.$dirty) return errors
      !this.$v.accountName.required &&
        errors.push(this.$t('bots.reqField')); 
      return errors
    },
  },
  methods: {
    mutateBot(command) {
      let validated = true
      let config = {}

      this.$v.$touch()
      if(this.$v.$invalid) return

      this.config_schema.forEach((item)=>{
        let field = this.$refs[item.key][0]

        if (item.field == 'checkbox' &&  field[item.key] == null)
          field[item.key] = false

        config[item.key] = field[item.key]
        if(field.$v != undefined ) {
          field.$v.$touch()
          if(field.$v.$invalid) {
            validated = false
            return
          }
        }
      })
      if (validated) {
        this.loading = true;  
        if (command == 'install') {
          this.$apollo.mutate({
            mutation: CREATE_USERBOT_MUTATION,
            variables: {
              account_name: this.accountName,
              bot_id: this.$route.params.id,
              config: JSON.stringify(config)
            }       
          }).then(data => {
              this.loading = false
              this.$router.go(-1)
          }).catch(error => {
              this.errorHandler(error)
              this.loading = false; 
          })
        }  
        if (command == 'update') {
          this.$apollo.mutate({
            mutation: MANAGE_USERBOT_MUTATION,
            variables: {
              command: 'change',
              user_bot_id: this.$route.query.ubid,
              account_name: this.accountName,
              config: JSON.stringify(config)
            }       
          }).then(data => {
            this.$router.push('/traderbots/mybot/' + this.$route.query.ubid)
          }).catch(error => {
              this.errorHandler(error)
              this.loading = false; 
          })
        }
      }
    }
  },
  validations () {
    return {
      accountName: {
        required
      }
    }
  },
  apollo: {
    bot: {
      query: BOT_INSTALL_QUERY,
      variables() {
        return {
          id: this.$route.params.id
        }
      },
      result(data) {
        if (data.loading == false) {
          this.config_schema = JSON.parse(data.data.bot.config_schema)
        }
      },
    },
    userBot: {
      query: USER_BOT_QUERY,
      variables() {
        return {
          id: this.$route.query.ubid
        }
      },
      skip() {
        return this.$route.query.ubid == undefined
      },
      result(data) {
        if (data.loading == false) {        
          this.accountName = data.data.userBot.account_name
          this.botConfig = JSON.parse(data.data.userBot.config)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  
</style>
